"use client";

import { Row, Col, Flex, Result, Button } from "antd";
import { useEffect } from "react";
import img from "@/images/404.png";
import tykkitLogo from "@/images/tykkit.png";
import Link from "next/link";
import Image from "next/image";
import { useLayout } from "@/lib/LayoutContext";

export default function NotFound() {
  const { setHideFooter } = useLayout();

  useEffect(() => {
    setHideFooter(true);
    return () => setHideFooter(false);
  }, [setHideFooter]);

  return (
    <div style={{ padding: "2rem", marginBottom: 80, textAlign: "center" }}>
      <Row>
        <Col
          xs={24}
          md={{ span: 20, offset: 2 }}
          lg={{ span: 12, offset: 6 }}
          xl={{ span: 8, offset: 8 }}
        >
          <Flex vertical align="center">
            <div style={{ marginBottom: "2rem" }}>
              <Image
                src={tykkitLogo}
                alt="Tykkit"
                width={120}
                height={40}
                style={{ objectFit: "contain" }}
              />
            </div>
            <Result
              icon={
                <Flex justify="center" className="w-full">
                  <img
                    src={img.src}
                    alt="404"
                    style={{ height: 300, width: "auto" }}
                  />
                </Flex>
              }
              title={
                <div className="text-black ff-title font-bold">
                  🎭 Lost in the Crowd?
                </div>
              }
              subTitle="Looks like this page missed its cue. Let's get you back where the real action is - events, vibes, and tickets that actually exist."
              extra={
                <Link href={"/"}>
                  <Button type="primary">Take me back to base</Button>
                </Link>
              }
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
}
